<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)"
                srcset="assets/img/school-desktop-banners/arni-school-of-hotel-management-and-tourism.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/school-desktop-banners/medium-screen/arni-school-of-hotel-management-and-tourism.webp">
        <img
            src="assets/img/mobile-banners-schools/arni-school-of-hotel-manegement-and-tourism.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>
<section class="aarni-font py-12">
    <div class="container mx-auto p-4">
        <div
            class="md:flex flex-wrap hidden space-x-4 p-6 xl:p-4 mb-4 border-2 border-gray-200 rounded-full gap-y-3 mx-auto xl:justify-center">
            <a href="#overview"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400  active-tab">Overview</a>
            <a href="#courses"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Courses</a>
            <a href="#specialisation"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Specialization</a>
            <a href="#hod-message"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">HOD's
                Message</a>
            <a href="#whats-happening"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">What's
                Happening</a>
            <a href="#expert-faculty"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Expert
                Faculty</a>
            <!--<a href="#testimonials"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Testimonials</a>-->
            <a href="#gallery"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Gallery</a>
            <a href="#recruiters"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Recruiters</a>
        </div>

        <div id="overview" class="section p-4">
            <h2 class="text-3xl font-bold mb-2">Arni School of Hotel Management & Tourism</h2>
            <h2 class="text-xl font-bold mb-2">Overview</h2>
            <p class="text-gray-500 text-justify font-medium">The ARNI School of Hotel Management & Tourism is a vibrant
                hub of aspiring hospitality professionals, combining creativity, professionalism, and a global
                perspective. With the increase of tourism, travel, and luxury lifestyle experiences, the demand for
                hotel management expertise is increasing rapidly. We at ARNI are committed to producing highly
                professional individuals with relevant skills, confidence, and an adaptable nature that can excel in a
                competitive environment.
            </p>
            <p class="text-gray-500 text-justify">
                As an educational institution, we provide a dynamic learning environment that combines academic rigor
                with practical training. From culinary arts to front office management and event planning to luxury
                hospitality, our programs are designed to immerse students in every aspect of the hospitality and
                tourism sectors. Our focus is on creating skilled professionals who are not only good managers of
                hotels, resorts, and restaurants but also proficient in business, communication, and customer service
                skills.
            </p>
            <p class="text-gray-500 text-justify">The curriculum covers theoretical knowledge and practical concepts
                with industry exposure, internships, and practical assignments to ensure students will not just have
                relevant degrees but also have industry-ready skills and experience. We aim to equip students with
                leadership qualities, professionalism, creativity, and problem-solving abilities.
            </p>
            <p class="text-gray-500 text-justify my-2"><strong>Vision -</strong> The goal is to establish a globally
                recognized center for hospitality education and innovation, empowering students to lead and transform
                the hospitality industry through creativity, excellence, and sustainability.</p>
            <p class="text-gray-500 text-justify my-2"><strong>Mission -</strong> Our mission is to become a hub that
                offers a comprehensive program equipped with theoretical and practical knowledge to students for diverse
                roles in the hospitality and tourism industry.
            </p>
        </div>

        <div id="courses" class="section px-4">
            <h2 class="text-xl font-bold mb-2">Courses</h2>
            <p class="text-gray-500 text-justify">The School of Hotel Management & Tourism at ARNI University offers a
                diverse range of programs designed to meet the dynamic needs of the global hospitality and tourism
                industry. With a perfect blend of theoretical foundations and practical applications, our programs
                prepare students to excel in various facets of hospitality, including hotel operations, culinary arts,
                tourism management, and luxury services.
            </p>
            <p class="text-gray-500 text-justify">Our industry-driven curriculum, delivered by experienced faculty and
                complemented by state-of-the-art
                facilities, ensures that students are well-equipped with the knowledge, skills, and confidence to
                succeed in a competitive market. The program covers all aspects of hotel management and offers a
                Bachelor of Science in culinary management, B.Sc Hospitality & Culinary Management, and B.Sc Hospitality
                & Hotel Administration, including front office operations, food and beverage services, housekeeping, and
                hospitality marketing. The Hotel Management and Catering Technology (BHMCT) courses are for aspiring
                chefs, focusing on the art of cooking, food presentation, and culinary innovation.
            </p>
            <p class="text-gray-500 text-justify"><strong>Scope:</strong> The Hotel Management & Tourism Courses offer
                unparalleled opportunities for personal and professional growth in one of the world's fastest-growing
                industries. The course offers numerous options to specialize in areas like culinary arts, hotel
                operations, tourism management, and more.
            </p>
            <ul class="list-disc px-5">
                <li class="text-gray-500 text-justify my-2">Hospitality is one of the largest and fastest-growing
                    industries worldwide. Graduates from hotel management programs are in demand across sectors,
                    including tourism, food services, events, airlines, and luxury resorts.
                </li>
                <li class="text-gray-500 text-justify my-2"> Due to the global nature of the industry, graduates often
                    find exciting international opportunities. Countries like the UAE, Singapore, Australia, and
                    European nations actively recruit Indian hospitality professionals.
                </li>
                <li class="text-gray-500 text-justify my-2">For those with business acumen, hotel management provides
                    the perfect foundation to start a restaurant, café, event management firm, or hospitality
                    consultancy.
                </li>
                <li class="text-gray-500 text-justify my-2">The booming event industry, especially wedding planning in
                    India, requires hospitality experts for logistics, guest experience, catering, and coordination.
                </li>
                <li class="text-gray-500 text-justify my-2">Graduates can also explore roles in teaching or hospitality
                    research, contributing to curriculum development and innovative practices.
                </li>
                <li class="text-gray-500 text-justify my-2">With a degree in hotel management, students are also
                    eligible for various roles in state and central tourism departments, offering job security and
                    prestige.
                </li>
            </ul>
            <h4 class="text-xl font-bold mb-2">Career Opportunities</h4>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2"><span class="font-semibold">Hotel Manager / Resort Manager -</span> With
                    the rise in hotels and resorts, professionals with managerial skills are required. They can manage
                    hotel day-to-day operations, including staff, budget, guest services, and maintain service quality
                    to ensure customer satisfaction.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Food and Beverage Manager -</span> To ensure
                    food quality, hygiene, and regulations, food and beverage managers are required. They can work in
                    bars, restaurants, and banquets to ensure good customer experience and team coordination.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Event Coordinator / Wedding Planner -</span>
                    Personal events or professional meetings offer diversified career opportunities. Event coordinators
                    and wedding planners manage logistics, vendors, décor, and guest experience from start to finish.
                </li>
                <li class="text-gray-500 my-2"><span
                    class="font-semibold">Cruise and Airline Hospitality Executive -</span> Work with luxury cruise
                    liners and international airlines to ensure top-notch in-flight or onboard hospitality services.
                </li>
                <li class="text-gray-500 my-2"><span
                    class="font-semibold">Entrepreneur / Hospitality Consultant -</span> Start your own business in
                    catering, cafés, or event management—or offer consulting services to hospitality ventures for growth
                    and performance improvement.
                </li>
            </ul>

            <h2 class="text-xl font-bold mb-2">Arni University’s Contribution to Emerging Technologies</h2>
            <p class="text-gray-500 my-2">ARNI University is not about classes alone. Our School of Hotel Management &
                Tourism makes use of the global hospitality industry by combining academic knowledge with practices
                based on real-world examples. Our students learn not just in the comfort of traditional classrooms, but
                in modern training kitchens, model hotel rooms, front-office simulation labs, and have exposure to all
                leading national and international hotel chains. Our strong bond and engagement with industry experts
                grant internships and professional exposure to every ARNI student with reputable brands in the
                business.</p>
            <p class="text-gray-500 my-2">ARNI University does not only teach academic pursuits; We are holistic, with
                soft skills training programs, grooming sessions, and foundational workshops based on the latest trends
                within the hospitality industry. Our experienced professors, industry mentors, and placement team
                comprehensively support students from the classroom to career.
            </p>
            <p class="text-gray-500 my-2">Encouraging all students' ideas regardless of their trueness and mentoring
                growing entrepreneurs, ARNI creates a sustainable environment of helping students discover their passion
                and capabilities. Our enlightening and illuminating alumni are visible all over the world carrying the
                brand of professionalism, excellence, and higher-order thinking that the ARNI University tagline
                represents.
            </p>

            <h2 class="text-xl font-bold mb-2">Why Choose ARNI?</h2>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2">Our course framework has been constructed with the help of professionals
                    in the fields of hospitality, ensuring that it is informed by collective wisdom, contemporary
                    trends, and practical skills.
                </li>
                <li class="text-gray-500 my-2">ARNI collaborates with respected hotel groups and tourism boards,
                    providing students with real experiences and placement opportunities.
                </li>
                <li class="text-gray-500 my-2">We have modern laboratories for food production, pro-comms bakery,
                    housekeeping, and front office that simulate hotel environments.
                </li>
                <li class="text-gray-500 my-2">Placement cells are dedicated to ensuring students have access to timely
                    internships and job offers domestically and internationally.
                </li>
                <li class="text-gray-500 my-2">Guest lectures, workshops by international hospitality professionals, and
                    exchange programs provide students with global exposure at the start of their careers.
                </li>
                <li class="text-gray-500 my-2">We have experienced academics and former hospitality executives who
                    provide teaching staff with current and relevant experiences to inform their assessments.
                </li>
            </ul>

            <p class="my-2 text-gray-500 font-semibold">With experienced faculty members, well-equipped labs, and strong
                industry connections, ARNI School of Hotel Management & Tourism is the best place to passion into a
                profession.
            </p>
        </div>
    </div>
    <div id="specialisation" class="w-full bg-gray-100">
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">Hotel & Tourism Disciplines &
                Specializations</h2>
            <div class="flex justify-center">
                <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 gap-6">
                    <div
                        *ngFor="let department of departments"
                        class="bg-white p-5 w-full rounded-2xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                    >
                        <div class="flex items-center mb-4">
                            <i class="fa" [ngClass]="department.icon + ' text-2xl text-blue-600 mr-3'"></i>
                            <span class="text-xl font-semibold text-gray-800">{{ department.name }}</span>
                        </div>
                        <div class="max-h-40 overflow-y-auto custom-scrollbar pr-2">
                            <ul class="list-disc pl-6 text-sm text-gray-700 space-y-1">
                                <li *ngFor="let branch of department.branches">{{ branch }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-gradient-to-b from-indigo-500 to-blue-400 text-white py-8  text-center mt-6">
            <div class="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 py-8">
                <div>
                    <p class="text-3xl font-bold">200+</p>
                    <p class="text-lg">Programs</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">500+</p>
                    <p class="text-lg">Faculties</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">11000+</p>
                    <p class="text-lg">Students</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">120+</p>
                    <p class="text-lg">Acre of campus</p>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full">
        <div id="hod-message"
             class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4">
            <div class="relative w-full md:w-1/3">
                <img src="assets/img/hods-as-per-schools/deepak-dubey-arni-school-of-hotel-management.png" alt="Dean"
                     class="w-full h-full object-cover">
                <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2">
                    Dr. Deepak Dubey
                </div>
            </div>
            <div class="w-full md:w-2/3 p-6 overflow-y-auto h-auto custom-scrollbar">
                <h2 class="text-2xl font-bold mb-2">HOD’s Message</h2>
                <p class="text-gray-700 text-justify">
                    “Atithi Devo Bhava”
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    As a Bhartiya, this is not just a phrase for us; this is the feeling and respect we have for our
                    guests in our hearts that leads us to be the best hosts and serve lasting long memories. However,
                    the hospitality industry is just about food and shelter, which are the basic needs of tourists and
                    visitors, but the essence of the best customer services and comfort make it beyond this!
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    We at ARNI School of Hotel Management & Tourism did the same!
                </p>
                <p class="text-gray-700 mt-4 text-justify">Serving as the dean, I am very proud and excited to welcome
                    you all to ARNI University, one of the best educational institutes situated in Himachal Pradesh that
                    not only comes as the hope for ‘Himachalis’ but has a number of students from around the world.</p>
                <p class="text-gray-700 mt-4 text-justify">By keeping our curriculum up to date with the most recent
                    developments in the field, we at ARNI University's School of Hotel Management & Tourism strive to
                    make hospitality and tourism education not only diversified but also integrative.</p>
                <p class="text-gray-700 mt-4 text-justify">We take pride in being one of the leading hotel management &
                    tourism institutes in India.</p>
                <p class="text-gray-700 mt-2 text-justify">All the best to all of you.</p>
                <p class="text-gray-700 mt-2 text-justify">Regards</p>
                <p class="text-gray-700 mt-2 text-justify font-bold">Dr. Deepak Dubey</p>
                <p class="text-gray-700 mt-2 text-justify">ARNI School of Hotel Management & Tourism</p>
            </div>

        </div>

        <div id="whats-happening" class="w-full">
            <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
                <div class="container mx-auto px-6">
                    <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <div *ngFor="let event of events" class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img [src]="event.image" alt="Event Image" class="w-full h-56 object-cover">
                            <div class="p-4">
                                <span
                                    class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8">Event</span>
                                <!-- <p class="text-sm text-gray-600 font-bold mt-3">{{ event.date }}</p>-->
                                <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                                <p class="text-sm text-gray-600 mt-2">{{ event.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center mt-10">
                        <a
                            href="/whats-happening/event-calendar"
                            class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                        >
                            View More
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div id="expert-faculty" class="w-full">
            <div class="relative w-full md:flex flex-col items-center bg-gray-100 py-8 hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="relative w-full max-w-6xl overflow-hidden">
                    <div
                        class="flex justify-center transition-transform duration-300 ease-in-out"
                        [ngStyle]="{ transform: 'translateX(' + translateX + '%)' }"
                    >
                        <div
                            *ngFor="let faculty of faculties"
                            class="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4"
                        >
                            <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                                <div class="h-[140px] flex items-center justify-center">
                                    <img
                                        [src]="faculty.image"
                                        alt="faculty image"
                                        class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                    />
                                </div>
                                <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                    <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                    <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    (click)="prev()"
                    class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-left text-[#012E26]"></i>
                </button>
                <button
                    (click)="next()"
                    class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-right text-[#012E26]"></i>
                </button>
                <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                        (click)="goTo('/about/faculty')">
                    View All Faculty
                </button>
            </div>
            <div class="relative w-full sm:flex flex-col items-center bg-gray-100 py-8 md:hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="w-full">
                    <div
                        *ngFor="let faculty of faculties | slice:0:3"
                        class="flex flex-col items-center p-4"
                    >
                        <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                            <div class="h-[140px] flex items-center justify-center">
                                <img
                                    [src]="faculty.image"
                                    alt="faculty image"
                                    class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                />
                            </div>
                            <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center">
                    <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                            (click)="goTo('/about/faculty')">
                        View All Faculty
                    </button>
                </div>
            </div>
        </div>

        <!--<div id="testimonials" class="py-16 bg-white font-montserrat">
            <div class="container mx-auto px-4 text-center">
                <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
                <div class="testimonial-slider relative">
                    <div class="overflow-hidden px-2">
                        <div
                            class="flex transition-transform duration-500 ease-in-out"
                            [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                        >
                            <ng-container *ngFor="let group of groupedTestimonials">
                                <div class="w-full flex-shrink-0 flex pb-4">
                                    <div
                                        *ngFor="let testimonial of group"
                                        class="w-full md:1/2 lg:w-1/3 px-3"
                                    >
                                        <div
                                            class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                            <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                                <div
                                                    class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                                >
                                                    <div class="w-24 h-24 rounded-full bg-white p-1">
                                                        <img
                                                            [src]="testimonial.image"
                                                            [alt]="testimonial.name"
                                                            class="w-full h-full rounded-full object-cover"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-16 pb-8 px-6">
                                                <h3
                                                    class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                                >
                                                    {{ testimonial.name }}
                                                </h3>
                                                <div class="flex justify-center mb-4">
                                                    <i
                                                        class="fa fa-star text-yellow-400"
                                                        *ngFor="let star of [1, 2, 3, 4, 5]"
                                                    ></i>
                                                </div>
                                                <p class="text-gray-700 text-center mb-6">
                                                    {{ testimonial.feedback }}
                                                </p>
                                                <div class="text-center text-sm text-gray-600">
                                                    <p class="font-semibold">{{ testimonial.course }}</p>
                                                    &lt;!&ndash;        <p class="font-bold text-[#012E26]">
                                                                Placed In:
                                                                <span class="text-[#00BFA5]">
                                  {{ testimonial.company }}
                                </span>
                                                            </p>&ndash;&gt;
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    &lt;!&ndash; Pagination Dots &ndash;&gt;
                    <div class="flex justify-center mt-8 space-x-2">
                        <button
                            *ngFor="let group of groupedTestimonials; let i = index"
                            [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                            class="w-3 h-3 rounded-full transition-all duration-300"
                            (click)="setTestimonialSlide(i)"
                        ></button>
                    </div>
                </div>

                <div class="flex justify-center mt-10">
                    <a
                        href="/quick-links/student-testimonial"
                        class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
                    >
                        View More
                    </a>
                </div>
            </div>
        </div>-->

        <div id="gallery">
            <div class="container-fluid mb-10">
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-3/5 md:pr-4 mb-4 md:mb-0">
                        <img src="assets/img/academic-blocks/block-c.jpg" alt="Image 1"
                             class="w-full h-[500px] shadow-lg">
                    </div>
                    <div class="w-full md:w-2/5 md:pl-4">
                        <iframe class="w-full h-[500px] object-cover shadow-lg"
                                src="https://www.youtube.com/embed/RSa3v7KV2h4?si=qWzM2swYFmjZ0Sgm"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div id="recruiters" class="w-full">
            <div class="bg-blue-100 text-center font-sans py-12">
                <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
                <div class="flex items-center justify-center gap-6 py-4">
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="prevSlide()">&#10094;
                    </button>
                    <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                        <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                             [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                            <div *ngFor="let recruiter of recruiters"
                                 class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                                <img [src]="recruiter.logo" [alt]="recruiter.name"
                                     class="max-w-[80px] sm:max-w-[100px] h-auto">
                            </div>
                        </div>
                    </div>
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="nextSlide()">&#10095;
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
